import React, { useEffect, useState } from "react";
import VerifySleepDataForm from "./verify-sleep-data-form";
import VerifiedSleepData from "./verified-sleep-data";
export default function VerifySleepDataWrapper({
    devices,
    onNextStep,
    setAlertDetails,
    forceShowVerifiedToken = 0,
    formData,
    setFormData,
}) {
    const [showVerifiedSleepData, setShowVerifiedSleepData] = useState(false);

    useEffect(() => {
        if (forceShowVerifiedToken > 0 && formData) {
            setShowVerifiedSleepData(true);
        }
    }, [forceShowVerifiedToken, formData]);

    return (
        <>
            {!showVerifiedSleepData && (
                <VerifySleepDataForm
                    devices={devices}
                    setFormData={setFormData}
                    setShowVerifiedSleepData={setShowVerifiedSleepData}
                    formData={formData}
                    setAlertDetails={setAlertDetails}
                />
            )}
            {showVerifiedSleepData && (
                <VerifiedSleepData
                    formData={formData}
                    setShowVerifiedSleepData={setShowVerifiedSleepData}
                    onNextStep={onNextStep}
                    setAlertDetails={setAlertDetails}
                />
            )}
        </>
    );
}
